import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Demo = () => {
  return (
    <Container fluid className="p-5">
      <Helmet>
        <title>Demo - QuickyChat</title>
        <meta name="description" content="Watch the demo to see how easy it is to create, customize, and deploy your own AI chatbot using our platform." />
        <meta name="keywords" content="AI chatbot, demo, QuickyChat, create chatbot, customize chatbot, deploy chatbot" />
      </Helmet>
      {/* Title and Description */}
      <Row className="mb-4 text-center">
        <Col>
          <h1 className="mb-3">Explore Our App in Action</h1>
          <p>
            Watch the demo to see how easy it is to create, customize, and deploy your own AI agnet
          </p>
        </Col>
      </Row>

      {/* Video Embed */}
      <Row className="justify-content-center mb-4">
        <Col md={8}>
          <div className="ratio ratio-16x9">
            {/* <iframe width="1281" height="721" src="https://www.youtube.com/embed/Dkd33FZeQVc" title="QuickyChat.com | Build Intelligent AI Agents in Minutes" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}
            <iframe
              width="1281"
              height="721"
              src="https://www.youtube-nocookie.com/embed/nH03bHHrRtM?rel=0&modestbranding=1"
              title="YouTube video player"
              frameBorder="0"
              allowFullScreen>
            </iframe>
          </div>
        </Col>
      </Row>

      {/* Call to Action */}
      <Row className="text-center py-5">
        <Col>
          <h3 className="mb-3">Ready to Get Started?</h3>
          <p>
            Sign up today and begin creating intelligent, customized agents that work for you.
          </p>
          <Link to="/dashboard">
				<Button variant="primary" size="lg">
					Start Building for Free
				</Button>
			</Link>
        </Col>
      </Row>
    </Container>
  );
};

export default Demo;
